export {LinkInternal} from './LinkInternal';
